import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c4ab318"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_3 = ["textContent", "onClick"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "prefix", {}, () => [
        _hoisted_2
      ], true),
      _createElementVNode("span", {
        class: _normalizeClass(["menu-wrapper", {'--small': $props.small}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.headers, (obj, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            textContent: _toDisplayString(obj),
            class: _normalizeClass(["menu", {'--selected': $props.selected === index, '--small h6': $props.small}]),
            onClick: () => $setup.onSelected(index)
          }, null, 10, _hoisted_3))
        }), 128))
      ], 2),
      _renderSlot(_ctx.$slots, "suffix", {}, () => [
        _hoisted_4
      ], true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.headers, (_, index) => {
      return _renderSlot(_ctx.$slots, index, { key: index }, undefined, true)
    }), 128))
  ], 64))
}